/**
 * UnreadBadge Component
 * Badge per messaggi non letti
 */

interface UnreadBadgeProps {
  count: number;
  className?: string;
}

export function UnreadBadge({ count, className = '' }: UnreadBadgeProps) {
  if (count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count;

  return (
    <span
      className={`
        inline-flex items-center justify-center
        min-w-[18px] h-[18px] px-1
        text-[11px] font-medium text-white
        bg-[#2383E2] rounded-full
        ${className}
      `}
    >
      {displayCount}
    </span>
  );
}
